import { Layers } from 'lucide-react';
import { useUI } from '@/data/stores';
import { Toggle } from '@/components';
import './map.css';

export function LayerPanel() {
  const layers = useUI((s) => s.layerVisibility);
  const toggle = useUI((s) => s.toggleLayer);
  const notify = useUI((s) => s.notifyAction);
  const toggleLayer = (key: keyof typeof layers) => {
    const enabled = !layers[key];
    toggle(key);
    if (key === 'geofences' || key === 'weather' || key === 'infraNetwork') {
      notify({
        title: `${layerLabel(key)} ${enabled ? 'shown' : 'hidden'}`,
        body: layerBody(key, enabled),
      });
    }
  };

  return (
    <div className="iris-layer-panel">
      <header>
        <Layers size={14} strokeWidth={1.5} />
        <span>Layers</span>
      </header>
      <div className="iris-layer-rows">
        <Toggle
          checked={layers.assets}
          onChange={() => toggleLayer('assets')}
          label="Assets"
        />
        <Toggle
          checked={layers.dependencies}
          onChange={() => toggleLayer('dependencies')}
          label="Dependencies"
        />
        <Toggle
          checked={layers.vessels}
          onChange={() => toggleLayer('vessels')}
          label="Vessels (AIS)"
        />
        <Toggle
          checked={layers.threats}
          onChange={() => toggleLayer('threats')}
          label="Threats"
        />
        <Toggle
          checked={layers.geofences}
          onChange={() => toggleLayer('geofences')}
          label="Protection zones"
        />
        <Toggle
          checked={layers.weather}
          onChange={() => toggleLayer('weather')}
          label="Weather risk"
        />
        <Toggle
          checked={layers.infraNetwork}
          onChange={() => toggleLayer('infraNetwork')}
          label="Infra network"
        />
      </div>
    </div>
  );
}

function layerLabel(key: string) {
  switch (key) {
    case 'geofences':
      return 'Protection zones';
    case 'weather':
      return 'Weather risk';
    case 'infraNetwork':
      return 'Infrastructure network';
    default:
      return key;
  }
}

function layerBody(key: string, enabled: boolean) {
  if (!enabled) return 'Layer removed from the geospatial operating picture.';
  switch (key) {
    case 'geofences':
      return 'Asset protection zones are visible with zone type, rule purpose, radius and source on hover.';
    case 'weather':
      return 'Forecast disruption cells are now visible with exposed-asset counts and confidence on hover.';
    case 'infraNetwork':
      return 'Physical and operational infrastructure corridors are now visible.';
    default:
      return 'Layer added to the geospatial operating picture.';
  }
}
